import { useEffect, useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import type { TextAreaProps } from "@/ui/core";
import { TextArea } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<TextAreaProps> = {
  title: "Core/Text Area",
  component: TextArea,
  argTypes: {
    errorMessage: { control: "text" },
    hasError: { control: "boolean" },
    isBorderless: { control: "boolean" },
    isDisabled: { control: "boolean" },
    maxLength: { control: "number" },
    onChange: { action: "Changed" },
    placeholder: { control: "text" },
    value: { control: "text" },
  },
  args: {
    isBorderless: false,
    placeholder: "Placeholder",
    value: "",
  },

  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [value, setValue] = useState<null | string | undefined>(args.value);

    useEffect(() => {
      setValue(args.value);
    }, [args.value]);

    return (
      <Box width="100%">
        <TextArea
          {...args}
          onChange={(newValue) => {
            setValue(newValue);
            args.onChange(newValue);
          }}
          placeholder={args.placeholder}
          value={value}
        />
      </Box>
    );
  },
};

type Story = StoryObj<TextAreaProps>;

const Primary: Story = {};

const Borderless: Story = {
  args: {
    isBorderless: true,
  },
};

const Disabled: Story = {
  args: {
    isDisabled: true,
  },
};

const WithCharacterCount: Story = {
  args: {
    maxLength: 500,
    placeholder: "Write your personal note here...",
  },
};

const WithError: Story = {
  args: {
    errorMessage: "This field is required",
    hasError: true,
    maxLength: 500,
    placeholder: "Write your personal note here...",
  },
};

export { Borderless, Disabled, Primary, WithCharacterCount, WithError };
export default StoryMeta;
